module.exports = __webpack_public_path__ + "b1a5be0e62562015498a687e24082fcf.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_large_x1/public/games/coh_image_3.png
// module id = 490
// module chunks = 0